import React from 'react';
import { connect } from 'react-redux'

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import { TextFieldHelper } from '../../Components/Fields';
import { doPost } from '../../Redux/Actions'
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import DatePickerContainer from '../../Components/DatePickerContainer';

const ENDPOINT = "kalender"

export const Fields = ({handleChange, name, datum}) => (
    <Grid container spacing={8}>

        <TextFieldHelper n={8} value={name} onChange={handleChange('name')} label="Name" />

        <Grid item xs={4}>
            <DatePickerContainer
                dateInput
                name="datum"
                label="Datum"
                value={datum}
                onChange={handleChange('datum')}
            />
        </Grid>

    </Grid>
)

class NewEntry extends Master {

	state = {
		newEntry: {}
	}

	render() {

		var {
			handleClickOpen, dialogOpen
		} = this.props

        var {
        	newEntry
        } = this.state

		return (
			<Dialog
                title="Neuer Kalender Eintrag"
                saveAction={this.postData}
                closeAction={handleClickOpen}
                open={dialogOpen}
             >
				<Fields handleChange={this.handleChange} {...newEntry} />
			</Dialog>
		)
	}

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doPost: (data) => dispatch(doPost(ENDPOINT, "api/generic/" + ENDPOINT, data)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewEntry);


// WEBPACK FOOTER //
// ./src/Routes/Kalender/NewEntry.js